var $ = require("jquery");

$(document).on('click',
    'a[data-navigate-back]',
    () => {
        history.back();
    });

window.refreshDataTable = (dataTableId) => {
    dataTableId.split(",").forEach(function (id) {
        const $table = $(`#${id}`);
        if ($table.data('dataTableCreated')) { //some DT's may not be created yet (created dynamically on tab show)
            $table.DataTable().ajax.reload(null, false);
        }
        
    });
};


// WEBPACK FOOTER //
// ./App/containers/common.js